// extracted by mini-css-extract-plugin
var _1 = "_dailyGoldPrice-module__block-container";
var _2 = "_dailyGoldPrice-module__buy-price";
var _3 = "_dailyGoldPrice-module__container";
var _4 = "_dailyGoldPrice-module__gold-price-text";
var _5 = "_dailyGoldPrice-module__info-container";
var _6 = "_dailyGoldPrice-module__price";
var _7 = "_dailyGoldPrice-module__price-container";
var _8 = "_dailyGoldPrice-module__price-label";
var _9 = "_dailyGoldPrice-module__sell-price";
var _a = "_dailyGoldPrice-module__title";
export { _1 as "block-container", _2 as "buy-price", _3 as "container", _4 as "gold-price-text", _5 as "info-container", _6 as "price", _7 as "price-container", _8 as "price-label", _9 as "sell-price", _a as "title" }
